import useInbox from "../useInbox";

const useNOCInbox = ({ tenantId, filters, config, userBusinessServices }) => {
  const { applicationStatus, mobileNumber, applicationNumber, sortBy, sortOrder, locality, uuid, limit, offset } = filters;
  const excludedServices = ["BPA_LANDUSE_DA", "BPA_FAR_DA", "BPA_MAPSUB_DA"];

  // const currentBusinessService = userBusinessServices?.filter((item) => !excludedServices.includes(item));
  const USER_UUID = Digit.UserService.getUser()?.info?.uuid;
  console.log("userInfoFromNOCInbox", Digit.UserService.getUser(), userBusinessServices);

  const _filters = {
    tenantId,
    processSearchCriteria: {
      moduleName: "noc-services",
      businessService: [userBusinessServices],
      ...(applicationStatus?.length > 0 ? { status: applicationStatus } : {}),
      ...(uuid && Object.keys(uuid).length > 0 ? { assignee: uuid.code === "ASSIGNED_TO_ME" ? USER_UUID : "" } : {}),
    },
    moduleSearchCriteria: {
      ...(mobileNumber ? { mobileNumber } : {}),
      ...(applicationNumber ? { applicationNumber } : {}),
      ...(sortBy ? { sortBy } : {}),
      ...(sortOrder ? { sortOrder } : {}),
      ...(locality?.length > 0 ? { locality: locality.map((item) => item.name.split("_").pop()).join(",") } : {}),
    },
    limit,
    offset,
  };

  return useInbox({
    tenantId,
    filters: _filters,
    config: {
      select: (data) => ({
        statuses: data.statusMap,
        table: data?.items.map((application) => ({
          applicationId: application.businessObject.applicationNo,
          date: application.businessObject.auditDetails.createdTime,
          businessService: application.ProcessInstance.businessService,
          status: application.businessObject.applicationStatus,
          owner: application.businessObject?.landInfo?.owners?.[0]?.name,
          applicationType: application?.businessObject?.applicationType,
          userPhoto: application.businessObject?.landInfo?.owners?.[0]?.photo,
          location: application?.businessObject?.location1,
          registrationNo: application?.businessObject?.registrationNo,
          nextAction: application.ProcessInstance?.nextActions?.[0]?.action,
          department: application?.businessObject?.department,
          land_Id: application?.businessObject?.land_Id,
          ltpName: application?.businessObject?.professionaldetails?.name || application?.businessObject?.professionalInformation?.name,
          recievedTime: application?.businessObject?.auditDetails?.lastModifiedTime,
          sourceRefId: application?.businessObject?.sourceRefId,
        })),
        totalCount: data.totalCount,
      }),
      ...config,
    },
  });
};

export default useNOCInbox;
